import { motion } from "framer-motion";
import { ShieldCheck, Users, Sparkles } from "lucide-react";

const STATS = [
  { icon: Sparkles, label: "One-Stop Shop", value: "Vape & Smoke" },
  { icon: Users, label: "Friendly Staff", value: "Expert Guidance" },
  { icon: ShieldCheck, label: "Trusted", value: "21+ Compliant" },
];

export const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-24 md:py-32 px-6 md:px-12"
    >
      <div className="max-w-6xl mx-auto grid lg:grid-cols-2 gap-14 items-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
        >
          <span className="text-sm uppercase tracking-[0.25em] text-zinc-500">
            About Us
          </span>
          <h2 className="font-heading text-3xl md:text-5xl font-light tracking-tight mt-4 leading-tight">
            Your one-stop vape shop &amp; smoke store in{" "}
            <span className="text-gradient">Morrisville</span>
          </h2>
          <p className="mt-6 text-zinc-400 leading-relaxed">
            Smok City is your ultimate vape shop and smoke store in Morrisville, PA,
            at 411 W Trenton Ave. Founded by Ketan and Divya Sharma, we&apos;re a
            one-stop destination for all your vaping needs—from disposable vapes and
            tobacco products to smoking accessories, kratom, and THCA.
          </p>
          <p className="mt-4 text-zinc-400 leading-relaxed">
            We pride ourselves on exceptional customer service and an extensive
            selection of top brands and innovative devices like the Solaris 25000 and
            Flair Ultra. Whether you&apos;re a first-timer or a seasoned pro, our
            friendly team is here to elevate your experience—visit us today!
          </p>

          <div className="mt-10 grid grid-cols-3 gap-4">
            {STATS.map((s) => (
              <div
                key={s.label}
                data-testid={`about-stat-${s.label.toLowerCase().replace(/\s/g, "-")}`}
                className="glass rounded-2xl p-4 md:p-5"
              >
                <s.icon className="text-[#00e5ff] mb-3" size={22} />
                <div className="text-xs text-zinc-500">{s.label}</div>
                <div className="text-sm font-medium text-white mt-1">
                  {s.value}
                </div>
              </div>
            ))}
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.96 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="relative"
        >
          <div className="absolute -inset-4 bg-gradient-to-tr from-[#00e5ff]/20 to-[#39ff14]/20 blur-3xl rounded-full opacity-40" />
          <div className="relative rounded-3xl overflow-hidden border border-white/10">
            <img
              src="https://customer-assets-agu9un31.emergentagent.net/job_b691172f-bb5a-4c7d-82b8-24fe2538ea1e/artifacts/ug39aeey_Image%209-17-26%20at%2011.15%E2%80%AFAM.jpeg"
              alt="Smok City vape shop interior mural in Morrisville PA"
              className="w-full h-[460px] object-cover"
              loading="lazy"
            />
          </div>
        </motion.div>
      </div>
    </section>
  );
};
